export const firstStepFields = [
   {name: 'name', inputName: "Ім’я *"},
   {name: "studentId", inputName: "Id учня *"},
   {name: 'phoneNumber', inputName: "Номер телефону *"},
   {name: 'notes', inputName: "Нотаток"},

 ]
 
